// extracted by mini-css-extract-plugin
module.exports = {"container":"_1urefQ8f0sJITkwHhjo-PG","map":"_3RETsp9AGrqjTKe-bYmAVX","school":"_1gYiES5F0V-jSdlrGV8sDk","schoolName":"Xe339325pTIS0YSUIiIHI","location":"_1Zy7u8g4QTNGwogrNG0kd7"};